import * as THREE from "three";
import AppData from "../../app.data";

const appData = new AppData();

/**
 * Gets the closest space to the camera position
 * @param cameraPosition Current camera position
 * @param visibleOnly If true, only consider spaces with visibility set to true
 * @returns Object with space position and visibility, or null if no space found
 */
export const getClosestSpace = (cameraPosition: any, visibleOnly: boolean = false) => {
  const sceneHolder = appData.spaceScene?.getObjectByName("sceneHolder");
  if (!sceneHolder) {
    return null;
  }

  // Get all space objects (children that contain "Space-" in their names)
  const spaceObjects = sceneHolder.children.filter(child => child.name.includes("Space-"));

  if (spaceObjects.length === 0) {
    return null;
  }

  let closestSpace = null;
  let closestDistance = Infinity;

  for (const spaceObject of spaceObjects) {
    // Extract space number from name (e.g., "Space-1" -> "1")
    const spaceMatch = spaceObject.name.match(/Space-(\d+)/);

    if (!spaceMatch) {
      continue;
    }

    const spaceNumberFormatted = Number(spaceMatch[1]) - 1;
    
    // Exclude spaceNumberFormatted 6
    if (spaceNumberFormatted === 6) {
      continue;
    }
    
    const spaceVisibility = appData.galleryData.data.spaceProceduralParameters[spaceNumberFormatted];


    // If we only want visible spaces and this one is not visible, skip it
    if (visibleOnly && spaceVisibility === false) {
      continue;
    }

    // Calculate distance from camera to space
    const spacePosition = spaceObject.position;
    const distance = spacePosition.distanceTo(new THREE.Vector3(cameraPosition.x, cameraPosition.y, cameraPosition.z))

    // Check if this is the closest space so far
    if (distance < closestDistance) {
      closestDistance = distance;
      closestSpace = {
        spaceObject: spaceObject,
        spacePosition: spacePosition,
        spaceVisibility: spaceVisibility,
        spaceNumber: spaceNumberFormatted,
        distance: distance
      };
    }
  }

  return closestSpace;
}

export const checkIfCameraIsOutside = (cameraPosition: any) => {
  let computedCameraPosition = cameraPosition
  if (appData.spaceData?.type === "procedural") {
    // iterate though all procedural spaces and find the closest one

    let closestSpace = getClosestSpace(cameraPosition, false)

    if (closestSpace) {
      if (closestSpace.spaceVisibility === false) {
        let closestVisibleSpace = getClosestSpace(cameraPosition, true)

        if (closestVisibleSpace) {
          computedCameraPosition = closestVisibleSpace.spacePosition
        }
      }
    }
  }
  return computedCameraPosition
}

